import styled from "styled-components";
import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { FadeInAnimation } from "src/apps/components/fadeIn/FadeInAnimation";
import { useIdentityVerification } from "../../../hooks/identityVerification/useIdentityVerification";
import { useDocumentationArea } from "src/apps/hooks/useDocumentationArea";
import { IdentityVerificationDocumentTypes } from "src/contexts/identityVerification/domain/IdentityVerificationDocumentTypes";
import { IDENTITY_VERIFICATION_SIDES_PER_DOCUMENT_TYPE } from "src/contexts/identityVerification/domain/IdentityVerificationDocumentSidesPerDocumentType";
import { IdentityVerificationOrderBox } from "../components/orderBox/IdentityVerificationOrderBox";

export const IdentityVerificationUploaders = () => {
  const { identityVerifications } = useDocumentationArea();
  const { selectedCountry, selectedDocumentType } = useIdentityVerification();

  const documentSides =
    IDENTITY_VERIFICATION_SIDES_PER_DOCUMENT_TYPE[
      selectedDocumentType as IdentityVerificationDocumentTypes
    ];

  return (
    <Container>
      {selectedCountry && selectedDocumentType ? (
        <FadeInAnimation duration={0.7}>
          <Spacer>
            <UploadersContainer>
              {documentSides.map((side, index) => {
                return (
                  <IdentityVerificationOrderBox
                    order={identityVerifications[0]}
                    side={side}
                    key={index}
                  />
                );
              })}
            </UploadersContainer>
          </Spacer>
        </FadeInAnimation>
      ) : null}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const UploadersContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: stretch;
  gap: 2rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    grid-template-columns: 100%;
    gap: 1rem;
  }
`;

const Spacer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 2rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    margin-top: 0rem;
  }
`;
